var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVe = function SvgVe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M22.81 17.217A11.951 11.951 0 0 0 24 11.999c0-1.87-.428-3.64-1.19-5.217L12 5.738 1.19 6.782A11.952 11.952 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.218L12 18.26l10.81-1.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24a12 12 0 0 0 10.809-6.782H1.19A12 12 0 0 0 12 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m20.782 14.356-.633.495.275.756-.667-.45-.634.495.221-.773-.666-.45.804-.028.221-.773.276.756.803-.028ZM19.159 11.544l-.427.683.518.616-.781-.195-.426.682-.056-.802-.78-.195.745-.301-.056-.803.517.617.745-.302ZM16.672 9.458l-.167.787.697.402-.8.085-.167.786-.328-.735-.8.085.598-.539-.327-.734.697.402.597-.539ZM13.622 8.348l.112.797.792.14-.723.352.112.796-.559-.578-.723.352.378-.71-.559-.578.792.14.378-.711ZM10.377 8.348l.377.71.792-.14-.558.58.377.71-.723-.353-.558.578.112-.796-.723-.353.792-.14.112-.796ZM7.326 9.458l.598.539.696-.402-.327.734.598.539-.8-.085-.327.735-.167-.787-.8-.083.696-.403-.167-.787ZM4.84 11.544l.746.302.516-.616-.055.802.745.302-.78.194-.056.802-.426-.682-.781.195.517-.616-.426-.683ZM3.217 14.356l.804.028.275-.756.222.774.803.028-.666.45.221.773-.633-.495-.667.45.275-.757-.634-.495Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M22.809 6.782A12 12 0 0 0 11.999 0 12 12 0 0 0 1.19 6.782H22.81Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVe;